<swiper-container class="viewer-slider" init="false" navigation="true" #viewerSwiperRef thumbs-swiper=".thumbs-slider" [dir]="dir()">
    @if (initialized()) {
        @for (item of slides(); track i; let i = $index) {
            <swiper-slide class="art-board slide" [class.active]="active() === i">
                <div class="swiper-zoom-container">
                    @if (active() === i) {
                        <img
                            placeholder
                            priority
                            [ngSrc]="item.largeImage.path"
                            alt="{{ item.title || item.slug }}"
                            [width]="item.largeImage.width"
                            [height]="item.largeImage.height"
                            style="width: auto; height: auto; position: relative"
                        />
                    } @else {
                        <img
                            placeholder
                            [ngSrc]="item.largeImage.path"
                            alt="{{ item.title || item.slug }}"
                            [width]="item.largeImage.width"
                            [height]="item.largeImage.height"
                            style="width: auto; height: auto; position: relative"
                        />
                    }
                    <div class="swiper-lazy-preloader"></div>
                </div>
                @if (item.body?.length > 0) {
                    <div class="info">
                        @if (item.title?.length > 0) {
                            <h2 style="margin: 0; margin-bottom: 0.25em; text-align: center">
                                {{ item.title }}
                            </h2>
                        }
                        <!-- @if (item.body?.length > 0) {
                            <p style="margin: 0" [innerHTML]="item.body | html"></p>
                        } -->
                    </div>
                }
            </swiper-slide>
        }
    }
</swiper-container>

<div class="w-full max-w-screen-sm mx-auto flex content-center items-center justify-center">
    <swiper-container class="thumbs-slider" init="false" #thumbsSwiperRef [dir]="dir()">
        @if (initialized()) {
            @for (item of slides(); track i; let i = $index) {
                <swiper-slide [class.active]="active() === i">
                    <img
                        placeholder
                        [ngSrc]="item.smallImage.path"
                        fill
                        alt="{{ item.title || item.slug }}"
                        #imgEl
                        (error)="imgEl.onerror = null; imgEl.src = '{{item.mediumImage.path}}?view=1&attachment=inline&w=150'"
                    />
                </swiper-slide>
            }
        }
    </swiper-container>
</div>
